/* eslint-disable react/require-default-props */
import React from 'react';
import CardCounter from 'components/atoms/card_counter';
import SelectButton from 'components/atoms/select_button';
import { Container } from './styles';

interface FollowupHeaderProps {
  followupId: string;
  biddingIndex: number;
  isChecked: boolean;
  followupBiddingId: number;
  toggleSelected: (id: number, updateAll?: boolean) => void;
}

const FollowupHeader: React.FC<FollowupHeaderProps> = (props: FollowupHeaderProps) => {
  const { followupId, biddingIndex, isChecked, followupBiddingId, toggleSelected } = props;

  return (
    <Container>
      <div className="card-header bidding-bg-header bidding-info">
        <div className="row align-items-center">
          <CardCounter count={biddingIndex + 1} />
          <div className="bidding-item-header-buttons d-flex align-self-start mb-2 mb-md-0 d-print-none">
            <div
              className="position-relative databalloon"
              aria-label="Selecionar acompanhamento"
              data-balloon-pos="up"
            >
              <SelectButton
                id={parseInt(followupId, 10)}
                isChecked={isChecked}
                toggleSelected={toggleSelected}
                text=""
              />
            </div>
          </div>

          {/* {indexLabel} */}
          <div className="ml-md-auto ml-2 text-white mr-2">
            <div className="font-weight-bold mr-2">Licitação referente: {followupBiddingId}</div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default FollowupHeader;
